module.exports = __webpack_public_path__ + "img/2.3a1334b8.jpeg";